<template>
  <div>
    <Modal v-model="show" @on-ok="ok" :loading="loading" :mask-closable="false">
      <h3 slot="header" class="modal-header">{{`${text}房型`}}</h3>
      <div>
        <p>是否要{{text}}房型？</p> 
      </div>
    </Modal>
  </div>
</template>

<script>
  import {showOrForbid} from "api/houseTypeConfig";

  export default {
    name: "showOrHide",
    props:{
      n: {
        type: Number,
        default: 0
      },
      fid:{
        type:String,
        default:''
      },
      houseTypeConfigStatus:{
         type:Number,
         default:0
      }
    },
    computed:{
      text(){
        return this.houseTypeConfigStatus === 0 ? '隐藏': '显示'
      }
    },
    watch:{
      n(){
        this.show=true
      }
    },
    data(){
      return {
        show:false,
        loading:true,
      }
    },
    methods:{
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok(){
      
        let data = {
          houseTypeConfigFid: this.fid,
          houseTypeConfigStatus: this.houseTypeConfigStatus
        }
        showOrForbid(data).then(res=>{
          this.$Message.success(`${this.text}房型成功`)
          this.changeLoading()
          this.$emit('refresh')
          this.show = false
        }).catch(res => {
          this.show = false
        })
       
      }

    },

  }
</script>

<style scoped>

</style>
